__turbopack_context__.v({
  "container": "styles-module-scss-module__zoUaSq__container",
  "content_container": "styles-module-scss-module__zoUaSq__content_container",
  "tab_slider": "styles-module-scss-module__zoUaSq__tab_slider",
});
